// src/AboutPage.js (or src/pages/AboutPage.js)
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import Navbar from "./components/layout/Navbar";
import "./styles/aboutpage.css";
import SEO from "./components/SEO"; // ✅ ADD THIS LINE

import { Link } from 'react-router-dom';

export default function AboutPage() {
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const formRef = useRef(null);
  const navigate = useNavigate();

  const handleApplyNowClick = () => {
    document.querySelector(".abtpg-apply-section")?.scrollIntoView({ 
      behavior: "smooth", 
      block: "start" 
    });
  };

  // ✅ VALIDATION FUNCTION (Outside handleFormSubmit)
  const validateForm = () => {
    const newErrors = {};
    const formData = new FormData(formRef.current);
    
    // Name - letters only
    const name = formData.get('name')?.trim();
    if (!name || name.length < 2) {
      newErrors.name = 'Name must be at least 2 characters';
    } else if (!/^[a-zA-Z\s]+$/.test(name)) {
      newErrors.name = 'Name can only contain letters';
    }

    // Email
    const email = formData.get('email')?.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Phone - exactly 10 digits
    if (phone.length !== 10) {
      newErrors.phone = 'Phone must be exactly 10 digits';
    }

    // City - letters only
    const city = formData.get('city')?.trim();
    if (!city || city.length < 2) {
      newErrors.city = 'City must be at least 2 characters';
    } else if (!/^[a-zA-Z\s]+$/.test(city)) {
      newErrors.city = 'City can only contain letters';
    }

    // Course
    const course = formData.get('course');
    if (!course || course === '') {
      newErrors.course = 'Please select a course';
    }

    // Qualification
    const qualification = formData.get('qualification')?.trim();
    if (!qualification) {
      newErrors.qualification = 'Please enter qualification';
    }

    // Marks
    const marks = formData.get('marks')?.trim();
    if (!marks) {
      newErrors.marks = 'Please enter marks';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setErrors({});

    // Validate form
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const formData = new FormData(formRef.current);
    const templateParams = {
      name: formData.get('name'),
      email: formData.get('email'),
      phone: formData.get('phone'),
      city: formData.get('city'),
      course: formData.get('course'),
      qualification: formData.get('qualification'),
      marks: formData.get('marks'),
      message: formData.get('message') || 'No message',
      // ✅ CORRECT TRACKING FIELDS
      college_name: 'General - About Page',
        college_name: formData.get('college') || 'General - About Page',
  chosen_college: formData.get('college') || 'Not specified',

      form_source: 'about_page',
      page_url: window.location.href,
      submission_time: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
    };

    emailjs
      .send('service_u0g0bqj', 'template_naso7ph', templateParams, '0JNndpSn5KZm_5yLJ')
      .then(() => {
        setLoading(false);
        setFormSubmitted(true);
        formRef.current.reset();
        setPhone('');
        setErrors({});
        setTimeout(() => setFormSubmitted(false), 5000);
      })
      .catch((error) => {
        setLoading(false);
        console.error('EmailJS error', error);
        alert('Failed to submit. Please try again.');
      });
  };

  return (
    <>
      <SEO 
        title="About Us - College Aggregator | Your Trusted Education Partner in Dehradun"
        description="Learn about College Aggregator - Dehradun's leading education consultancy. We provide personalized college guidance, admission support, and transparent information for students since 2020. 900+ students placed, 95% success rate."
        keywords="about college aggregator, education consultancy dehradun, college admission guidance dehradun, student counseling services, college placement assistance, education partner uttarakhand"
        canonical="/about"
        ogImage="/images/Gemini_Generated_Image_v0iwwv0iwwv0iwwv.png"
        ogType="website"
      />
      <Navbar onApplyClick={handleApplyNowClick} />

      <div className="about-page-wrapper">
        
        {/* HERO SECTION */}
        <section className="abtpg-hero-section">
          <div className="abtpg-hero-container">
            <div className="abtpg-hero-content">
              <span className="abtpg-hero-badge">WHO WE ARE</span>
              <h1 className="abtpg-hero-title">
                COLLEGE <span className="abtpg-text-highlight">AGGREGATOR</span>
              </h1>
              <p className="abtpg-hero-description">
                CollegeAggregator is your trusted partner in navigating the complex world 
                of college admissions. We provide personalized guidance, transparent information, 
                and comprehensive support to help you make the best educational decisions.
              </p>
              <div className="abtpg-hero-stats">
                <div className="abtpg-stat-item">
                  <h3>900+</h3>
                  <p>Students Placed</p>
                </div>
                <div className="abtpg-stat-item">
                  <h3>20+</h3>
                  <p>Partner Colleges</p>
                </div>
                <div className="abtpg-stat-item">
                  <h3>95%</h3>
                  <p>Success Rate</p>
                </div>
              </div>
            </div>
            
            <div className="abtpg-hero-image">
              <div className="abtpg-image-wrapper">
                <img
                  src="/images/Gemini_Generated_Image_v0iwwv0iwwv0iwwv.png"
                  alt="Students collaboration"
                  onError={(e) => {
                    e.target.src = "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&h=400&fit=crop";
                  }}
                />
                <div className="abtpg-image-decoration"></div>
              </div>
            </div>
          </div>
        </section>

        {/* FEATURES SECTION */}
        <section className="abtpg-features-section">
          <div className="abtpg-section-container">
            <div className="abtpg-section-header">
              <span className="abtpg-section-badge">OUR SERVICES</span>
              <h2>Why Choose CollegeAggregator?</h2>
              <p>We offer comprehensive support to make your college admission journey seamless</p>
            </div>
            
            <div className="abtpg-features-grid">
              <div className="abtpg-feature-card">
                <div className="abtpg-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 14l9-5-9-5-9 5 9 5z"/>
                    <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
                  </svg>
                </div>
                <h3>One-on-One Counseling</h3>
                <p>Personalized guidance from experienced counselors who understand your goals and aspirations.</p>
              </div>

              <div className="abtpg-feature-card">
                <div className="abtpg-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                  </svg>
                </div>
                <h3>Verified College Reviews</h3>
                <p>Access authentic reviews and ratings from real students and alumni to make informed decisions.</p>
              </div>

              <div className="abtpg-feature-card">
                <div className="abtpg-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3>Fee Transparency</h3>
                <p>Compare college fees, hidden costs, and financial aid options across multiple institutions.</p>
              </div>

              <div className="abtpg-feature-card">
                <div className="abtpg-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                  </svg>
                </div>
                <h3>Performance Analytics</h3>
                <p>Review placement statistics, success rates, and alumni achievements of different colleges.</p>
              </div>

              <div className="abtpg-feature-card">
                <div className="abtpg-feature-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3>24/7 Support</h3>
                <p>Round-the-clock assistance for all your queries during the admission process.</p>
              </div>
            </div>
          </div>
        </section>






        {/* MISSION SECTION */}
        <section className="abtpg-mission-section">
          <div className="abtpg-mission-container">
            <div className="abtpg-mission-image">
              <img
                src="/images/girlbannerabtpg.webp"
                alt="Student reading"
                onError={(e) => {
                  e.target.src = "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&h=400&fit=crop";
                }}
              />
            </div>
            
            <div className="abtpg-mission-content">
              <span className="abtpg-section-badge">OUR MISSION</span>
              <h2>Empowering Education, Enabling Success</h2>
              <p className="abtpg-mission-text">
                At CollegeAggregator, we believe that every student deserves access to quality 
                education and transparent information. Our mission is to bridge the gap between 
                aspiring students and their dream colleges through personalized guidance and 
                data-driven insights.
              </p>
              <div className="abtpg-mission-points">
                <div className="abtpg-mission-point">
                  <div className="abtpg-point-icon">✓</div>
                  <div>
                    <h4>Accessibility</h4>
                    <p>Making quality education accessible to everyone, regardless of their background.</p>
                  </div>
                </div>
                <div className="abtpg-mission-point">
                  <div className="abtpg-point-icon">✓</div>
                  <div>
                    <h4>Transparency</h4>
                    <p>Providing honest, unbiased information to help you make informed decisions.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* APPLICATION FORM SECTION */}
        <section className="abtpg-apply-section">
          <div className="abtpg-apply-container">
            <div className="abtpg-apply-content">
              <span className="abtpg-section-badge light">READY TO START?</span>
              <h2>Begin Your Journey Today</h2>
              <p>
                Register now to receive personalized college recommendations and dedicated support throughout your admission process.
              </p>
              
              <div className="abtpg-benefits-list">
                <div className="abtpg-benefit-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Free career counseling</span>
                </div>
                
                <div className="abtpg-benefit-item">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Detailed college comparisons</span>
                </div>
              </div>

              <div className="abtpg-apply-image-desktop">
                <img
                  src="/images/Gemini_Generated_Image_6urmzm6urmzm6urm.png"
                  alt="Students discussing"
                  onError={(e) => {
                    e.target.src = "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=500&h=400&fit=crop";
                  }}
                />
              </div>
            </div>

            {/* FORM WRAPPER */}
            <div className="abtpg-apply-form-wrapper" style={{ maxWidth: '800px', width: '100%' }}>
              {!formSubmitted ? (
                <div className="abtpg-form-card">
                  <div className="abtpg-form-header">
                    <h3 className="abtpg-form-title">Get Started</h3>
                    <p className="abtpg-form-subtitle">Fill in your details and we'll reach out to you</p>
                  </div>

                  <form ref={formRef} onSubmit={handleFormSubmit} className="abtpg-form-stack">
                    {/* Full Name */}
                    <div>
                      <label className="abtpg-label">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Your full name"
                        required
                        className={`abtpg-input ${errors.name ? 'error' : ''}`}
                      />
                      {errors.name && <p className="abtpg-error">{errors.name}</p>}
                    </div>

                    {/* Email */}
                    <div>
                      <label className="abtpg-label">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Your email address"
                        required
                        className={`abtpg-input ${errors.email ? 'error' : ''}`}
                      />
                      {errors.email && <p className="abtpg-error">{errors.email}</p>}
                    </div>

                    {/* Mobile Number */}
                    <div>
                      <label className="abtpg-label">Mobile Number *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={phone}
                        maxLength="10"
                        placeholder="Your mobile number"
                        required
                        onChange={(e) => {
                          const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
                          setPhone(digits);
                          setErrors({ ...errors, phone: '' });
                        }}
                        className={`abtpg-input ${errors.phone ? 'error' : ''}`}
                      />
                      {errors.phone && <p className="abtpg-error">{errors.phone}</p>}
                    </div>

                    {/* City & Course Row */}
                    <div className="abtpg-form-row">
                      <div>
                        <label className="abtpg-label">City *</label>
                        <input
                          type="text"
                          name="city"
                          placeholder="Your City"
                          required
                          className={`abtpg-input ${errors.city ? 'error' : ''}`}
                        />
                        {errors.city && <p className="abtpg-error">{errors.city}</p>}
                      </div>




                      <div>
                        <label className="abtpg-label">Course *</label>
                        <select 
                          name="course" 
                          required 
                          className={`abtpg-input ${errors.course ? 'error' : ''}`}
                        >
                          <option value="">Select course</option>
                          <option value="btech-cse">B.Tech CSE</option>
                          <option value="bba">BBA</option>
                          <option value="bca">BCA</option>
                          <option value="mba">MBA</option>
                          <option value="other">Other</option>
                        </select>
                        {errors.course && <p className="abtpg-error">{errors.course}</p>}
                      </div>
                    </div>
<div>
  <label className="abtpg-label">Choose College *</label>
  <select name="college" required className="abtpg-input">
    <option value="">Select a college</option>
    <option value="UPES College">UPES College</option>
    <option value="Graphic Era University">Graphic Era University</option>
    <option value="UIT College">UIT College</option>
    <option value="HIT College">HIT College</option>
    <option value="Dev Bhoomi Uttarakhand University">Dev Bhoomi Uttarakhand University</option>
    <option value="GRD College">GRD College</option>
    <option value="DD College">DD College</option>
    <option value="Sai College">Sai College</option>
    <option value="Institute Of Technology & Management">Institute Of Technology & Management</option>
    <option value="Doon Group Of Colleges">Doon Group Of Colleges</option>
    <option value="Maya Group of Colleges">Maya Group of Colleges</option>
    <option value="Not Sure">Not Sure / Need Guidance</option>
  </select>
</div>


                    {/* Qualification & Marks Row */}
                    <div className="abtpg-form-row">
                      <div>
                        <label className="abtpg-label">Qualification *</label>
                        <input
                          type="text"
                          name="qualification"
                          placeholder="Your qualification e.g.,12th"
                          required
                          className={`abtpg-input ${errors.qualification ? 'error' : ''}`}
                        />
                        {errors.qualification && <p className="abtpg-error">{errors.qualification}</p>}
                      </div>

                      <div>
                        <label className="abtpg-label">Marks *</label>
                        <input
                          type="text"
                          name="marks"
                          placeholder="Your marks"
                          required
                          className={`abtpg-input ${errors.marks ? 'error' : ''}`}
                        />
                        {errors.marks && <p className="abtpg-error">{errors.marks}</p>}
                      </div>
                    </div>

                    {/* Message */}
                    <div>
                      <label className="abtpg-label">Message (Optional)</label>
                      <textarea
                        name="message"
                        rows="3"
                        placeholder="Any specific requirements or questions?"
                        className="abtpg-input abtpg-textarea"
                      ></textarea>
                    </div>

                    {/* Submit Button */}
                    <button type="submit" disabled={loading} className="abtpg-submit-btn">
                      {loading ? 'Submitting...' : 'Submit Application'} 
                      {!loading && <span>→</span>}
                    </button>
                  </form>
                </div>
              ) : (
                <div className="abtpg-form-card abtpg-success">
                  <div className="abtpg-success-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="abtpg-form-title">Application Submitted!</h3>
                  <p className="abtpg-form-subtitle">
                    Thank you for your interest. Our team will contact you within 24 hours.
                  </p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* SOCIAL SECTION */}
        <section className="abtpg-social-section">
          <div className="abtpg-social-container">
            <h3>Connect With Us</h3>
            <p>Follow us on social media for updates, tips, and success stories</p>
            <div className="abtpg-social-links">
              <a href="https://www.facebook.com/collegeaggregator" target="_blank" rel="noreferrer">
                <img src="/fb.png" alt="Facebook" />
              </a>
              <a href="https://instagram.com/collegeaggregator" target="_blank" rel="noreferrer">
                <img src="/insta.png" alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com/company/collegeaggregator/" target="_blank" rel="noreferrer">
                <img src="/linkedin.png" alt="LinkedIn" />
              </a>
            </div>
          </div>
        </section>
      </div>
      
      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <h3>CollegeAggregator</h3>
            <p>Helping students discover the right colleges with transparent data on courses, fees, and placements.</p>
          </div>

          <div className="footer-columns">
            <div className="footer-col">
              <h4>Support</h4>
              <a href="#counselling">Free Counselling</a>
              <a href="#faqs">FAQs</a>
              <a href="#contact">Contact Us</a>
            </div>

            <div className="footer-col">
              <h4>Contact</h4>
              <p>Email: collegeaggregator@gmail.com</p>
              <p>Mon–Sat, 10am–7pm IST</p>
              <div className="footer-social">
                <a href="https://www.facebook.com/collegeaggregator" target="_blank" rel="noreferrer">FB</a>
                <a href="https://instagram.com/collegeaggregator" target="_blank" rel="noreferrer">IG</a>
                <a href="https://www.linkedin.com/company/collegeaggregator/" target="_blank" rel="noreferrer">in</a>
                <a href="https://g.co/kgs/7wKFni" target="_blank" rel="noreferrer">G</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} CollegeAggregator. All rights reserved.</span>
          <div className="footer-links">
            <a href="#terms">Terms</a>
            <a href="#privacy">Privacy</a>
          </div>
        </div>
      </footer>
    </>
  );
}
